export function priceStringToCents(price: string): number {
  return Math.round(Number(price) * 100)
}
